import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/financials/messages";
import formatList from "./util/formatPayoutsList";

function* deletePayoutRequest(action) {
  const { success, data, error } = yield* makeRequest.delete(`/payouts/${action.payload.id}`, {});

  if (success && data) {
    yield all([
      put(actions.setPayoutsList(formatList(data))),
      put(actions.newSuccessEvent({ message: messages.SUCCESS_DELETING_PAYOUT })),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_DELETING_PAYOUT,
    });
  }

  return null;
}

export default deletePayoutRequest;
